import { useAtomValue } from 'jotai'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { surveyFilterAtom } from '~/atoms'
import { buildSurveyFilterTextGroups } from '~/utils'

import { useSurveyQueryAvailableBrandGroups } from './useSurveyQueryAvailableBrandGroups'
import { useSurveyQueryCustomerAttributeGroups } from './useSurveyQueryCustomerAttributeGroups'
import { useSurveyQueryQuestions } from './useSurveyQueryQuestions'

export const useSurveyQuerySurveyFilterTextGroups = () => {
  const { t } = useTranslation()
  const surveyFilter = useAtomValue(surveyFilterAtom)

  const questions = useSurveyQueryQuestions()
  const customerAttributeGroups = useSurveyQueryCustomerAttributeGroups()
  const brandGroups = useSurveyQueryAvailableBrandGroups()

  return React.useMemo(
    () =>
      buildSurveyFilterTextGroups({
        filterGroups: surveyFilter?.filterGroups ?? [],
        questions,
        customerAttributeGroups,
        brandGroups,
        t,
      }),
    [
      brandGroups,
      customerAttributeGroups,
      questions,
      surveyFilter?.filterGroups,
      t,
    ],
  )
}
